import { render } from "./CreateGroupForm.vue?vue&type=template&id=6001fbee"
import script from "./CreateGroupForm.vue?vue&type=script&lang=js"
export * from "./CreateGroupForm.vue?vue&type=script&lang=js"

import "./CreateGroupForm.vue?vue&type=style&index=0&id=6001fbee&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__